import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Card, Spin, Typography, Switch, Tooltip } from 'antd';
import React, { useEffect, useState, useMemo } from 'react';

import DataCollBasisEdit from './DataCollBasisEdit';

interface UploadTableEditingCardProps {
  dataCollName: string | undefined;
  client: { id: string; token: string; permissions: string[] };
  style?: React.CSSProperties;
  refreshKey?: number;
  hasBasisTable: boolean;
  hasBasisUploadTable: boolean;
  isEditable: boolean;
  expertModeActive: boolean;
}

// TODO add transform / validate and transform button. only enable/display it if       {isEditable(dataCollBlockedStatus) && allStructuralMappingsApplied && hasTableDiffs && ?
const UploadTableEditingCard: React.FC<UploadTableEditingCardProps> = ({
  dataCollName,
  client,
  style,
  refreshKey = 0,
  hasBasisTable,
  hasBasisUploadTable,
  isEditable, // is not blocked or blocked by current user or allow_data_editing is true
  expertModeActive,
}) => {
  const [loading, setLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(true);

  // Calculate showUploadTable based on current props
  const showUploadTable = useMemo(() => {
    // if no upload table is present but there is a basis table, show the basis table

    return hasBasisUploadTable || !hasBasisTable;
  }, [hasBasisUploadTable, hasBasisTable]);

  const [showUploadTableState, setShowUploadTableState] = useState(showUploadTable);

  // Update state when calculated value changes
  useEffect(() => {
    setShowUploadTableState(showUploadTable);
  }, [showUploadTable]);

  useEffect(() => {
    console.log('Die Vorschau der Basisdaten wurde aktualisiert.');
  }, [refreshKey]);

  if (!dataCollName) {
    return null;
  }

  const basisName = showUploadTableState ? `${dataCollName}_basis_upload` : `${dataCollName}_basis`;

  if (!hasBasisTable && !hasBasisUploadTable) {
    console.log('No basis table or upload table found');
    return null;
  } else {
    console.log(`hasBasisTable: ${hasBasisTable}, hasBasisUploadTable: ${hasBasisUploadTable}`);
    console.log(`showUploadTable: ${showUploadTableState}`);
    console.log(`dataCollName: ${dataCollName}`);
    console.log(`basisName: ${basisName}`);
  }

  // TODO: remove
  if (!expertModeActive) {
    return null;
  }

  return (
    <Card
      title={
        <Typography.Title
          style={{ margin: 0, cursor: 'pointer' }}
          level={3}
          onClick={() => setIsExpanded(!isExpanded)}
        >
          {showUploadTableState
            ? 'Bearbeitung der hochgeladenen Stammdatentabelle'
            : 'Aktive Stammdatentabelle'}
          {loading && <Spin style={{ marginLeft: 12 }} />}
        </Typography.Title>
      }
      extra={
        <div>
          {hasBasisUploadTable && hasBasisTable && (
            <Tooltip
              title={
                showUploadTableState
                  ? 'Hochgeladene Stammdatentabelle anzeigen'
                  : 'Aktive Stammdatentabelle anzeigen'
              }
            >
              <Switch
                checked={showUploadTableState}
                checkedChildren="Upload"
                unCheckedChildren="Aktiv"
                onChange={setShowUploadTableState}
                style={{ marginRight: 12 }}
              />
            </Tooltip>
          )}
          <Button
            type="text"
            icon={isExpanded ? <UpOutlined /> : <DownOutlined />}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        </div>
      }
      style={{ marginBottom: 12, ...style }}
    >
      {(hasBasisTable || hasBasisUploadTable) && isExpanded ? (
        <DataCollBasisEdit
          key={`${refreshKey}-${dataCollName}-${showUploadTableState ? 'upload' : 'basis'}`}
          client={client}
          // TODO: entscheiden, ob basis der aktuellen Portfoliodaten (also -portfolio) editierbar, falls ja mit Button erneut Transformation auszulösen
          dataCollBasisName={basisName}
          setLoading={setLoading}
          isEditable={isEditable}
        />
      ) : (
        <div style={{ textAlign: 'center', cursor: 'pointer' }} onClick={() => setIsExpanded(true)}>
          <Typography.Text type="secondary">
            Stammdatentabelle anzeigen und bearbeiten
          </Typography.Text>
        </div>
      )}
    </Card>
  );
};

export default UploadTableEditingCard;
